// let DOMAIN = 'https://ist-client.staging.siba-service.jp';
// let CHECKIN_DOMAIN = 'https://ist-checkin.staging.siba-service.jp';
let DOMAIN = '';
let CHECKIN_DOMAIN = '';



if (process.env.NODE_ENV === 'production') {
    DOMAIN = '';
    CHECKIN_DOMAIN = '';
}


export const CHANGE_MYPASSCODE = DOMAIN + '/api/change-mypasscode';
export const CK_CHANGE_MYPASSCODE = CHECKIN_DOMAIN + '/api/change-mypasscode';
export const GET_TIMETABLE = DOMAIN +'/api/get-timetable';
export const GET_RESERVE_AREA = DOMAIN +'/api/get-reserve-area';
export const GET_DENY_TIMETABLE = DOMAIN +'/api/get-deny-timetable';
export const GET_AVAILABLE_ITEMS = DOMAIN +'/api/get-available-items';
export const GET_AVAILABLE_ITEMS2 = DOMAIN + '/api/get-available-items2';

export const GET_AVAILABLE_TIME2 = DOMAIN + "/api/get-available-time2";

export const RESERVE_ITEM = DOMAIN + '/api/reserve-item';

export const GET_ALL_TICKETS = DOMAIN +'/api/get-all-tickets';
export const CHECKIN_GET_ALL_TICKETS = CHECKIN_DOMAIN + "/api/get-all-tickets";


export const GET_CAN_CHECKIN_TICKETS = CHECKIN_DOMAIN + '/api/get-can-checkin-tickets';
export const GET_CAN_CHECKOUT_TICKETS = CHECKIN_DOMAIN + '/api/get-can-checkout-tickets';

export const CANCEL_RESERVATION = DOMAIN +'/api/cancel-reservation';
export const CHECKIN_RESERVATION = CHECKIN_DOMAIN +'/api/checkin-reservation';
export const CHECKOUT_RESERVATION = CHECKIN_DOMAIN +'/api/checkout-reservation';
export const LOGOUT = DOMAIN +'/api/logout';

export const LOGIN = DOMAIN +'/api/login';
export const SIGNUP = CHECKIN_DOMAIN +'/api/signup';

export const GET_CURRENT_USER = DOMAIN +'/api/get-current-user';
export const GET_AVAILABLE_TENANTS = DOMAIN +'/api/get-available-tenants';


// WEBPACK FOOTER //
// ./src/jsx/common/components/constants.jsx